import styles from './MenuDelimiter.module.scss';

export interface IMenuDelimiterProps {
}

export function MenuDelimiter(props: IMenuDelimiterProps) {
    return (<div className={styles.host}>
    </div>);
}
